module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg2NCAxMjhhMzIgMzIgMCAwIDEgMzIgMzJ2NzA0YTMyIDMyIDAgMCAxLTMyIDMySDE2MGEzMiAzMiAwIDAgMS0zMi0zMlYxNjBhMzIgMzIgMCAwIDEgMzItMzJoNzA0eiBtLTE2MCAzNTJIMzIwYTMyIDMyIDAgMCAwIDAgNjRoMzg0YTMyIDMyIDAgMCAwIDAtNjR6IiBmaWxsPSIjMCIgcC1pZD0iMzAxOCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Shrink-filled.svg
// module id = 11Iz
// module chunks = 75